import axios from 'axios'
import qs from 'qs'
import Store from '@/store'
import { getStatus } from '@/utils'
import { Message, Loading } from 'element-ui'
import { removeStorage } from '@/utils/storage'

let loading = null

const service = axios.create({
  // 设置超时时间
  timeout: 6000,
  baseURL: window.$globalconfig.URLS.API,
})

// post请求的时候，我们需要加上一个请求头，所以可以在这里进行一个默认的设置
// 即设置post的请求头为application/x-www-form-urlencoded;charset=UTF-8
service.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
service.interceptors.request.use(
  config => {
    // 在请求先展示加载框
    loading = Loading.service({
      text: '加载中',
    })

    if (config.method === 'post' || config.method === 'put') {
      let data = qs.parse(config.data)
      config.data = qs.stringify({
        ...data,
      })
    } else if (config.method === 'get' || config.method === 'delete') {
      config.params = {
        ...config.params,
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  },
)

/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */
service.interceptors.response.use(
  response => {
    // 请求响应后关闭加载框
    if (loading) {
      setTimeout(() => {
        loading.close()
      }, 20)
    }

    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (getStatus(response)) {
      return Promise.resolve(response.data.data)
    } else {
      Message.error(response.data.msg)
      return Promise.reject(response)
    }
  },
  error => {
    // 断网 或者 请求超时 状态
    if (!error.response) {
      // 请求超时状态
      if (error.message.includes('timeout')) {
        console.log('超时了')
        Message.error('请求超时，请检查网络是否连接正常')
      } else {
        // 可以展示断网组件
        console.log('断网了')
        Message.error('请求失败，请检查网络是否已连接')
      }
      return
    }

    // 服务器返回不是 2 开头的情况，会进入这个回调
    // 可以根据后端返回的状态码进行不同的操作
    const responseCode = error.response.status
    switch (responseCode) {
      // 401：未登录
      case 401:
        Store.dispatch('TOGGLE_LOGIN')
        // window.location.href = window.$global.UserUrl + '?return_url=router.currentRoute.fullPath'
        break
      // 403: token过期
      case 403:
        // 弹出错误信息
        Message({
          type: 'error',
          message: '登录信息过期，请重新登录',
        })
        // 清除token
        removeStorage('userinfo')
        // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        setTimeout(() => {
          Store.dispatch('TOGGLE_LOGIN')
          // window.location.href = window.$global.UserUrl + '?return_url=router.currentRoute.fullPath'
        }, 1000)
        break
      // 404请求不存在
      case 404:
        Message({
          message: '网络请求不存在',
          type: 'error',
        })
        break
      // 其他错误，直接抛出错误提示
      default:
        Message({
          message: error.response.data.message,
          type: 'error',
        })
    }
    return Promise.reject(error)
  },
)

// 获取视频完整信息
export const getVideInfo = videoId => {
  return service.get(`api/videoview/videos/${videoId}`)
}

// 获取视频场景列表
export const getVideoScene = videoId => {
  return service.get(`api/videoview/videoscenes/${videoId}`)
}

// 获取场景视频中的热点
export const getSceneHotspots = sceneId => {
  return service.get(`/api/videoview/videoscenes/${sceneId}/hotspots`)
}

// 获取文章详情
export const getArticleDetail = id => {
  return service.get(`api/view/mats/${id}`)
}

// 获取场景视频中的评论
export const getComments = (
  videoId,
  pageIndex = 1,
  pageCount = 20,
  hastotalreplays = true,
) => {
  return service.get(
    `/api/user/video/${videoId}/comments/${pageIndex}/${pageCount}`,
    {
      params: {
        hastotalreplays,
      },
    },
  )
}

// 添加场景视频中的评论
export const addComments = opts => {
  return service.post(`/api/user/videocomments`, {
    ...opts,
  })
}

// 删除场景视频中的评论
export const delComments = _id => {
  return service.post(`/api/user/videocomments/${_id}`)
}

// 获取场景视频中的回复评论
export const getCommentsReply = (fkId, pageIndex = 1, pageSize = 20) => {
  return service.get(`/api/user/videoreplays/${pageIndex}/${pageSize}`, {
    params: {
      fk_comment_id: fkId,
    },
  })
}

// 添加场景视频中的回复评论
export const addCommentsReply = opts => {
  return service.post(`/api/user/videoreplays`, {
    ...opts,
  })
}

// 删除场景视频中的回复评论
export const delCommentsReply = _id => {
  return service.post(`/api/user/videoreplays/${_id}`)
}

// 点赞
export const addPraise = (videoId, token) => {
  return service.put(`/api/videoeditor/videopraises/${videoId}`, {
    token,
  })
}

// 收藏
export const addCollect = (videoId, token) => {
  return service.post(`/api/videoeditor/collects/${videoId}`, {
    token,
  })
}

// login
export const login = opts => {
  return service.post(`api/userlogin/login`, {
    ...opts,
  })
}

// weixin auth
export const wxAuth = (redirect, token) => {
  return service.get(`api/wxopen/authorize/wxget?return_url=${redirect}`)
}

// get user info
export const getWxUserInfo = token => {
  return service.get(`api/user/session?token=${token}`)
}

// urltoblob
export const transforUrlToBlob = url => {
  service.responseType = 'blob'
  return service.request(url)
}
// 获取微信分享参数
export const getWxShare = url => {
  return service.get('api/wxopen/share/get', {
    params: {
      url: url,
    },
  })
}
// // 获取弹幕
// export const getBarrage = (panoId) => {
//   return service.post('api/view/get_barrage', {
//     pano_id: panoId,
//     token: getToken()
//   })
// }

// // 添加弹幕
// export const addBarrage = (opts) => {
//   return service.post('api/viewsubmit/add_barrage', {
//     ...opts,
//     token: getToken()
//   })
// }

export default service
